var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E1E1E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.992 5.992c-2.332-2.727-6.222-3.46-9.145-.964s-3.334 6.673-1.039 9.626c1.909 2.455 7.684 7.634 9.576 9.31.212.188.318.282.441.318a.6.6 0 0 0 .334 0c.123-.036.23-.13.441-.318 1.893-1.676 7.668-6.855 9.576-9.31 2.295-2.953 1.934-7.155-1.039-9.626s-6.812-1.763-9.145.964",
    clipRule: "evenodd"
  })));
};
export default SvgHeart;